import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import ReactMarkdown from "react-markdown";
import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";
import WhatsAppFloat from "@/components/site/WhatsAppFloat";
import ContactCta from "@/components/site/ContactCta";
import { applySeo } from "@/lib/seo";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function BlogPost() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    setPost(null);
    setNotFound(false);
    axios
      .get(`${API}/blog/${slug}`)
      .then((res) => {
        setPost(res.data);
        applySeo({
          title: `${res.data.title} | Raffiel Nias`,
          description: res.data.meta_description,
          path: `/blog/${res.data.slug}`,
        });
      })
      .catch(() => setNotFound(true));
  }, [slug]);

  return (
    <div className="bg-sand-50 text-ink font-sans antialiased min-h-screen">
      <Navbar />
      <main>
        {notFound ? (
          <section className="py-32 text-center" data-testid="blog-post-not-found">
            <h1 className="font-display text-3xl font-bold text-ocean-900">Story not found</h1>
            <Link to="/blog" className="text-sm text-ocean-700 font-semibold underline mt-4 inline-block">
              Back to all stories
            </Link>
          </section>
        ) : !post ? (
          <section className="py-32 text-center text-sm text-fog">Loading story...</section>
        ) : (
          <>
            <section className="py-16 bg-sand-100 border-b border-sand-200" data-testid="blog-post-header">
              <div className="max-w-3xl mx-auto px-6">
                <Link to="/blog" className="text-xs font-semibold text-ocean-700 hover:underline">
                  &larr; All stories
                </Link>
                <h1 className="font-display text-3xl sm:text-5xl font-bold text-ocean-900 mt-4 leading-tight">
                  {post.title}
                </h1>
                <p className="text-xs font-mono-clean text-fog mt-4">
                  Raffiel Nias · Sorake Beach, Lagundri Bay ·{" "}
                  {new Date(post.created_at).toLocaleDateString("en-GB", {
                    day: "numeric",
                    month: "long",
                    year: "numeric",
                  })}
                </p>
              </div>
            </section>
            <article
              className="max-w-3xl mx-auto px-6 py-14 blog-content"
              data-testid="blog-post-content"
            >
              <ReactMarkdown>{post.content}</ReactMarkdown>
            </article>
            <ContactCta />
          </>
        )}
      </main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}
